jQuery(document).ready(function($) {
  $('.slick.marquee').slick({
     speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false,
    responsive: [
        {
          breakpoint: 768,
          settings: {
            speed: 3000,
          },
        }
      ],
  });
  
   $('.image-slider').slick({ 
    autoplay: true,
   	appendDots: $('.slider-dots'),
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots:true,
    arrows: false
  });
  
   $('.collection-slider').slick({
    autoplay: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    dots:false,
    arrows: true,
     prevArrow: '<div class="left_arrow"><img src="https://cdn.shopify.com/s/files/1/0513/0908/4831/files/left-arrow.png?v=1633492986"></div>',
     nextArrow: '<div class="right_arrow"><img src="https://cdn.shopify.com/s/files/1/0513/0908/4831/files/left-arrow.png?v=1633492986"></div>',
     responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            adaptiveHeight: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ]
  });
  
});
